import React from 'react';

interface IProps {
	children: React.ReactNode;
}

export const FormTabs: React.FC<IProps> = ({ children }) => (
	<div className="px-4 border-0 border-b border-solid border-grey-03-new flex items-end gap-2" data-test="FormTabs">
		{children}
	</div>
);
